// Mock data for PT Hiring Solutions clone — all static content lives here.

export const IMAGES = {
  hero: "https://images.unsplash.com/photo-1672380135241-c024f7fbfa13?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjY2NzZ8MHwxfHNlYXJjaHwxfHxwcm9mZXNzaW9uYWwlMjBoYW5kc2hha2UlMjBidXNpbmVzc3xlbnwwfHx8fDE3ODY1MTYyMTR8MA&ixlib=rb-4.1.0&q=85",
  tech: "https://images.unsplash.com/photo-1504384308090-c894fdcc538d?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjAzMjd8MHwxfHNlYXJjaHwzfHxtb2Rlcm4lMjB0ZWNoJTIwb2ZmaWNlJTIwcHJvZmVzc2lvbmFsc3xlbnwwfHx8fDE3ODY1MTYyMDR8MA&ixlib=rb-4.1.0&q=85",
  boardroom: "https://images.unsplash.com/photo-1769740333462-9a63bfa914bc?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NTY2NzR8MHwxfHNlYXJjaHwxfHxleGVjdXRpdmUlMjBtZWV0aW5nJTIwYm9hcmRyb29tJTIwY29ycG9yYXRlfGVufDB8fHx8MTc4NjUxNjIwM3ww&ixlib=rb-4.1.0&q=85",
};

export const NAV_LINKS = [
  { label: "Home", path: "/" },
  { label: "About", path: "/about" },
  { label: "Founder", path: "/founder" },
  { label: "Services", path: "/services" },
  { label: "Employers", path: "/employers" },
  { label: "Job Seekers", path: "/job-seekers" },
  { label: "Contact", path: "/contact" },
];

export const CONTACT_INFO = {
  email: "Preeti.thakur@pthiringsolutions.com",
  phone: "+91 90155 55567",
  phoneHref: "+919015555567",
  location: "Noida, India — hiring PAN-India",
  linkedin: "https://www.linkedin.com/company/pt-hiring-solutions/",
};

export const CLIENTS = {
  eyebrow: "Our Clients",
  title: "Trusted by teams that hire well.",
  intro:
    "From high-growth product companies to specialised deep-tech firms — organisations partner with us to build teams that last.",
  items: [
    {
      name: "Scalene Livprotec Pvt. Ltd.",
      location: "Bangalore",
      logo: "/assets/client-livprotec.webp",
      desc: "",
    },
    {
      name: "Proficio Business Solutions Pvt. Ltd.",
      location: "Bangalore",
      logo: "/assets/client-proficio.jpeg",
      desc: "Technology & Business Hiring — supported talent acquisition requirements, including assignments associated with NVIDIA India.",
    },
    {
      name: "IOTomation Ecotech Pvt. Ltd.",
      location: "Noida",
      logo: "/assets/client-iotomation.png",
      desc: "",
    },
  ],
};

export const MARQUEE_ITEMS = [
  "IT Recruitment",
  "Non-IT Hiring",
  "Executive Search",
  "C-Suite Leadership",
  "Finance & Banking",
  "Engineering",
  "Sales & Marketing",
  "Human Resources",
  "Operations",
  "Junior to Leadership",
];

// ---------------- HOME ----------------
export const HOME = {
  eyebrow: "PT Hiring Solutions — Recruitment, Refined",
  titleLines: [
    { plain: "Finding ", accent: "talent." },
    { plain: "Driving ", accent: "success." },
  ],
  description:
    "A boutique recruitment agency led by 15+ years of HR expertise — placing exceptional people across IT and Non-IT roles, from rising juniors to transformative C-suite leaders.",
  primaryCta: { label: "Hire with us", path: "/contact" },
  secondaryCta: { label: "Find your next role", path: "/job-seekers" },
  badge: { value: "15+", label: "Years in HR" },

  manifesto: {
    eyebrow: "The PT Way",
    title: "Our manifesto",
    intro:
      "Three principles that have guided every search we've ever run — and every relationship we've ever kept.",
    items: [
      {
        num: "01",
        title: "Partnership, not placement",
        body: "We don't fill vacancies — we build teams. Every search begins with understanding your culture, your ambition, and the kind of person who will thrive inside it.",
      },
      {
        num: "02",
        title: "Precision over volume",
        body: "Fifteen years of HR leadership taught us one thing: the right shortlist of three beats a pile of thirty. We screen deeply so you interview meaningfully.",
      },
      {
        num: "03",
        title: "Discretion, always",
        body: "From confidential C-suite mandates to sensitive leadership transitions, every conversation stays exactly where it belongs — with us.",
      },
    ],
  },

  whatWeDo: {
    eyebrow: "What we do",
    title: "Two worlds. One standard.",
    cards: [
      {
        chapter: "Chapter 01",
        title: "IT Recruitment",
        body: "Engineers, architects, data scientists, product leaders — the people building what's next.",
        image: IMAGES.tech,
        path: "/services",
      },
      {
        chapter: "Chapter 02",
        title: "Non-IT Hiring",
        body: "Finance, sales, marketing, HR, operations — the functions that keep great companies running.",
        image: IMAGES.boardroom,
        path: "/services",
      },
    ],
  },

  founder: {
    eyebrow: "The Founder",
    quote: [
      { plain: '"Great hiring isn\'t about resumes. It\'s about ' },
      { accent: "reading people" },
      { plain: ' — and I\'ve spent fifteen years doing exactly that."' },
    ],
    body: "Preeti Thakur founded PT Hiring Solutions after more than a decade and a half leading HR functions — building teams, shaping culture, and learning what truly makes a hire succeed.",
    cta: { label: "Meet the founder", path: "/founder" },
    stats: [
      { value: "15+", label: "Years of HR expertise" },
      { value: "2", label: "Domains — IT & Non-IT" },
      { value: "Jr → CXO", label: "Every level covered" },
    ],
  },

  cta: {
    title: "Your next great hire is one conversation away.",
    button: { label: "Start the conversation", path: "/contact" },
  },
};

// ---------------- ABOUT ----------------
export const ABOUT = {
  eyebrow: "About us",
  titleLines: ["Built on fifteen years", "of reading people."],
  intro:
    "PT Hiring Solutions is a boutique recruitment agency founded by Preeti Thakur — an HR veteran who has spent her career on the inside of hiring, and now brings that insight to every search she runs.",
  founderName: "Preeti Thakur",
  founderRole: "Founder & Principal Consultant",
  founderBlurb:
    "15+ years of HR leadership — hiring across IT and Non-IT, from promising juniors to the boardroom.",
  logo: "/assets/logo.png",
  story: [
    {
      num: "01",
      title: "Fifteen years inside HR",
      body: "Before founding PT Hiring Solutions, Preeti led HR across fast-growing organisations — hiring hundreds of professionals and learning first-hand why some hires transform a company while others quietly leave.",
    },
    {
      num: "02",
      title: "A recruiter who speaks HR",
      body: "Because she has sat on the other side of the table, Preeti understands what hiring managers actually need — not just what the job description says.",
    },
    {
      num: "03",
      title: "PT Hiring Solutions is born",
      body: "Founded on a simple conviction: recruitment should feel like counsel, not commerce. Every mandate, from junior roles to C-suite searches, gets the same rigour.",
    },
  ],
  pullQuote: {
    text: '"I\'ve interviewed thousands of candidates and partnered with hundreds of hiring managers. The best hires always come from the same place — someone took the time to truly understand both sides."',
    author: "— Preeti Thakur",
  },
  values: {
    eyebrow: "What we stand for",
    title: "Values that hire well.",
    items: [
      { num: "01", title: "Integrity", body: "Honest counsel — even when it means telling you the role isn't ready to fill." },
      { num: "02", title: "Confidentiality", body: "Sensitive searches stay sensitive. Candidate and client trust is everything." },
      { num: "03", title: "Craft", body: "Deep screening, real references, and shortlists we stake our name on." },
      { num: "04", title: "Longevity", body: "We measure success in retention, not invoices." },
    ],
  },
  cta: { label: "Work with Preeti", path: "/contact" },
};

// ---------------- SERVICES ----------------
export const SERVICES = {
  eyebrow: "Services",
  titleLines: ["Every role. Every level.", "Junior to C-suite."],
  intro:
    "From a startup's first engineer to a conglomerate's next CEO — PT Hiring Solutions runs searches across IT and Non-IT functions with the same boutique rigour.",
  blocks: [
    {
      num: "01",
      title: "IT Recruitment",
      body: "Technology moves fast; great technologists move faster. We maintain living relationships with engineering and product talent across the market, so when you need them, we already know them.",
      points: [
        "Software Engineers & Architects",
        "Data Science & Analytics",
        "Cloud, DevOps & Infrastructure",
        "Product, QA & Engineering Leadership",
      ],
      image: IMAGES.tech,
    },
    {
      num: "02",
      title: "Non-IT Hiring",
      body: "The functions that hold a company together deserve the same search rigour as its technology team. We place the operators, sellers, and strategists who turn plans into performance.",
      points: [
        "Finance, Accounting & Banking",
        "Sales & Marketing",
        "Human Resources & Admin",
        "Operations, Legal & Supply Chain",
      ],
      image: IMAGES.boardroom,
    },
  ],
  levels: {
    eyebrow: "Levels we place",
    items: [
      { num: "01", title: "Junior & Fresher" },
      { num: "02", title: "Mid-Level Specialists" },
      { num: "03", title: "Senior & Leadership" },
      { num: "04", title: "C-Suite & Board" },
    ],
  },
  process: {
    eyebrow: "How we deliver",
    title: "A search process with no shortcuts.",
    steps: [
      { num: "01", title: "Discovery", body: "A deep briefing on the role, the team, the culture — and the person who will actually succeed in it." },
      { num: "02", title: "Search", body: "Targeted mapping across our network and the market. We approach the people you'd never find on a job board." },
      { num: "03", title: "Shortlist", body: "Rigorously screened, reference-checked candidates — a short list you can trust, not a long one you have to filter." },
      { num: "04", title: "Placement & beyond", body: "Offer management, onboarding support, and follow-through after day one. Our work ends when the hire works." },
    ],
  },
  cta: { label: "Brief us on a role", path: "/contact" },
};

// ---------------- EMPLOYERS ----------------
export const EMPLOYERS = {
  eyebrow: "For Employers",
  titleLines: ["Hire the person,", "not just the profile."],
  intro:
    "When you brief PT Hiring Solutions, you're not commissioning a resume mill — you're gaining a hiring partner who has sat in your chair and knows exactly what a great hire looks like.",
  cta: { label: "Brief us on a role", path: "/contact" },
  reasons: {
    eyebrow: "Why partner with us",
    title: "A recruiter who thinks like a hiring manager.",
    items: [
      { num: "01", title: "Fewer, sharper CVs", body: "We send you a shortlist of three you'd genuinely hire — not thirty you have to sift." },
      { num: "02", title: "HR-grade screening", body: "Fifteen years inside HR means we read culture fit, motivation, and risk the way you would." },
      { num: "03", title: "Confidential mandates", body: "Replacing a leader quietly? Building a stealth team? Discretion is built into every search." },
      { num: "04", title: "Retention, not churn", body: "We measure our success by who's still thriving a year later, not by the placement fee." },
    ],
  },
  engagements: {
    eyebrow: "How we engage",
    title: "Choose the search that fits the seat.",
    items: [
      { num: "01", title: "Contingent Search", body: "For volume and mid-level roles where speed and reach matter most." },
      { num: "02", title: "Retained Search", body: "For leadership and C-suite mandates that demand depth, discretion, and dedication." },
      { num: "03", title: "Advisory & Mapping", body: "Market intelligence, compensation benchmarking, and org design counsel before you even hire." },
    ],
  },
  cta2: {
    title: "Tell us who you need. We'll find who fits.",
    button: { label: "Start the conversation", path: "/contact" },
  },
};

// ---------------- JOB SEEKERS ----------------
export const JOB_SEEKERS = {
  eyebrow: "For Job Seekers",
  titleLines: ["Your next chapter,", "handled with care."],
  intro:
    "Whether you're writing your first resume or considering a board seat, you deserve a recruiter who treats your career like it matters — because to us, it does.",
  cta: { label: "Introduce yourself", path: "/contact" },
  journey: {
    eyebrow: "The candidate journey",
    title: "How we work with you.",
    items: [
      { num: "01", title: "We listen first", body: "Your ambitions, your constraints, your non-negotiables. Before we ever mention a role, we understand what 'right' means for you." },
      { num: "02", title: "Confidential by default", body: "Exploring quietly? Your search stays invisible until you decide otherwise. Your current employer will never hear it from us." },
      { num: "03", title: "Real preparation", body: "Honest briefings on the company, the culture, and the interviewers. You walk in knowing exactly what matters." },
      { num: "04", title: "Beyond the offer", body: "Salary negotiation, resignation support, onboarding check-ins. We stay with you well past signing day." },
    ],
  },
  whoWeHelp: {
    eyebrow: "Who we help",
    title: "From first job to corner office.",
    items: [
      { num: "01", title: "Early-career professionals", body: "Land the role that actually builds your career — not just any offer." },
      { num: "02", title: "Seasoned specialists", body: "Move sideways into growth, or upward into leadership, with counsel at every step." },
      { num: "03", title: "Senior leaders & CXOs", body: "Discreet, retained-level attention for transitions that shape organisations." },
    ],
    image: IMAGES.boardroom,
  },
  cta2: {
    title: "Ready when you are. No pressure, ever.",
    body: "Send us a note with your resume or simply tell us where you want to go. If we have something right for you, you'll hear from us personally.",
    button: { label: "Start a confidential conversation", path: "/contact" },
  },
};

// ---------------- FOUNDER ----------------
export const FOUNDER = {
  eyebrow: "The Founder",
  titleLines: ["A message from", "our founder."],
  intro:
    "Every search we run carries the conviction of the person who started it. Meet the leader behind PT Hiring Solutions.",
  name: "Preeti Thakur",
  role: "Founder, PT Hiring Solutions",
  credential: "MBA in Human Resources · 15+ years in HR leadership",
  bio:
    "Preeti Thakur is an MBA in Human Resources with 15+ years of experience driving talent strategy across the Manufacturing, Logistics, IT, and Energy Management sectors. Her cross-industry expertise allows her to understand the unique hiring challenges each sector faces — from technical and operational roles to leadership positions — and match them with the right talent.",
  industries: ["Manufacturing", "Logistics", "Information Technology", "Energy Management"],
  messageHeading: "Welcome, and thank you for visiting.",
  message: [
    "When I started PT Hiring Solutions, my dream wasn't to build something big — it was to build something unique. I believed that with the right team and honest effort, that vision would come true.",
    "Over 15+ years in HR leadership across manufacturing, logistics, IT, and energy management, I've seen firsthand how a single strategic hire can redefine a company's trajectory. That belief is at the heart of everything we do.",
    "Our mission at PT Hiring Solutions is simple: to make hiring less complex and more meaningful — bringing deep industry expertise to help companies build future-ready teams, and helping candidates find roles where they can truly thrive.",
    "Thank you for being here. I look forward to being part of your journey — whether you're building a team or building a career.",
  ],
  signature: "Preeti Thakur",
  signatureRole: "Founder, PT Hiring Solutions",
  highlights: [
    { value: "15+", label: "Years in HR leadership" },
    { value: "4", label: "Industries mastered" },
    { value: "Jr → CXO", label: "Every level placed" },
  ],
  cta: { title: "Let's build your next chapter together", button: { label: "Start the conversation", path: "/contact" } },
};

// ---------------- CONTACT ----------------
export const CONTACT = {
  eyebrow: "Contact",
  titleLines: ["Let's talk about", "your next move."],
  intro:
    "Hiring for your team or exploring your own next role — every enquiry is read personally by our founder. Expect a reply within one business day.",
};
